
const categories = [
  {
    "name": "all",
    "label": "ALL"
  },
  {
    "name": "news",
    "label": "NEWS"
  },
  {
    "name": "event",
    "label": "EVENT & FAIR"
  },
  {
    "name": "other",
    "label": "OTHERS"
  },

];

export default categories;




// WEBPACK FOOTER //
// ./src/data/topics-categories.js